import React from 'react';
import { useLocation } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

const parentPathFrom = (pathname: string) => {
  const clean = pathname.replace(/\/+$/, '');
  const bits = clean.split('/');
  if (bits.length <= 2) return '/';
  return bits.slice(0, -1).join('/') || '/';
};

export const ParentLink: React.FC = () => {
  const location = useLocation();
  const parent = parentPathFrom(location.pathname);

  return (
    <p>
      <FormattedMessage
        id="error.parent.link"
        defaultMessage="One level up {parent}"
        values={{ parent: <a href={parent}>{parent}</a> }}
      />
    </p>
  );
};

export default ParentLink;
